module.exports = __webpack_public_path__ + "video/2200-3_YR_2021_MaliciousApps.5447b297.vtt";